// eslint-disable-next-line no-unused-vars
import webpackEntry from 'webpack-entry';

import packageJson from '../../package.json';
import { PluginManifest, PluginStore } from 'graylog-web-plugin/plugin';
import ArchivePage from './ArchivePage';
import ArchiveConfigurationPage from './ArchiveConfigurationPage';
import ArchiveBackendsPage from './ArchiveBackendsPage';
import ArchiveBackendConfigurationPage from './ArchiveBackendConfigurationPage';
import ArchiveRetentionStrategyConfiguration from 'components/ArchiveRetentionStrategyConfiguration';
import ArchiveRetentionStrategySummary from 'components/ArchiveRetentionStrategySummary';

PluginStore.register(new PluginManifest(packageJson, {
  routes: [
    { path: '/system/archives/configuration', component: ArchiveConfigurationPage },
    { path: '/system/archives/backends', component: ArchiveBackendsPage },
    { path: '/system/archives/backends/new', component: ArchiveBackendConfigurationPage },
    { path: '/system/archives/backends/:backendId', component: ArchiveBackendConfigurationPage },
    { path: '/system/archives', component: ArchivePage },
  ],

  systemnavigation: [
    { path: '/system/archives', description: 'Archives', permissions: 'archive:read' },
  ],

  indexRetentionConfig: [
    {
      type: 'org.graylog.plugins.archive.indexer.retention.strategies.ArchiveRetentionStrategy',
      displayName: 'Archive Index',
      configComponent: ArchiveRetentionStrategyConfiguration,
      summaryComponent: ArchiveRetentionStrategySummary,
    },
  ],
}));



// WEBPACK FOOTER //
// ./src/web/index.jsx